'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

const outlineBase = styled.css`
  outline-color: transparent;
  outline-offset: ${({ theme  })=>`${theme.outline.offset}px`};
  outline-style: ${({ theme  })=>theme.outline.style};
  outline-width: ${({ theme  })=>`${theme.outline.width}px`};
`;

exports.outlineBase = outlineBase;
//# sourceMappingURL=outline.js.map
